import React, { useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import Toast from "../../../../../common/toast";
import Spinner from "../../../../../common/spinner";
import apiCall from "../../../../../../apicall";
import { useSelector } from "react-redux";
import ReactQuill from "react-quill";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { formatCompanyName } from "../../../../../../globals/fomat-comapny-name";

const AddJobTypeForm = () => {
  const { TOKEN } = useSelector((state) => state.menu)

  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [formValues, setFormValues] = useState({
    typeName: "",
    shortDescription: "",
    longDescription: "",
    relatedDocuments: "",
    relatedFields: "",
    relatedJobFields: "",
  });
  const [errSuccessMesg, setErrSuccessMsg] = useState({
    message: "",
    status: "error",
  });

  const [formErrors, setFormErrors] = useState({});
  const navigateToProfessionsList = () => {
    navigate(`/professions`);
  };

  const validateForm = () => {
    const errors = {};

    // Validate fields common to both roles
    if (!formValues.typeName || formValues.typeName.trim() === "") {
      errors.typeName = "Profession is required.";
    }

    if (!formValues.shortDescription || formValues.shortDescription.trim() === "") {
      errors.shortDescription = "Short Description is required.";
    }

    if (!formValues.longDescription || formValues.longDescription.trim() === "") {
      errors.longDescription = "Long Description is required.";
    }

    if (!formValues.relatedDocuments || formValues.relatedDocuments.trim() === "") {
      errors.relatedDocuments = "Documents are required.";
    } else {
      try {
        const parsed = JSON.parse(formValues.relatedDocuments);
        if (!Array.isArray(parsed)) {
          errors.relatedDocuments = "Documents must be a JSON array.";
        }
      } catch (e) {
        errors.relatedDocuments = "Invalid JSON format.";
      }
    }

    if (!formValues.relatedFields || formValues.relatedFields.trim() === "") {
      errors.relatedFields = "Job Seeker Profile Questions are required.";
    } else {
      try {
        const parsed = JSON.parse(formValues.relatedFields);
        if (!Array.isArray(parsed)) {
          errors.relatedFields = "Job Seeker Profile Questions must be a JSON array.";
        }
      } catch (e) {
        errors.relatedFields = "Invalid JSON format.";
      }
    }

    if (!formValues.relatedJobFields || formValues.relatedJobFields.trim() === "") {
      errors.relatedJobFields = "Post Job Form Questions are required.";
    } else {
      try {
        const parsed = JSON.parse(formValues.relatedJobFields);
        if (!Array.isArray(parsed)) {
          errors.relatedJobFields = "Post Job Form Questions must be a JSON array.";
        }
      } catch (e) {
        errors.relatedJobFields = "Invalid JSON format.";
      }
    }

    // Log errors for debugging
    console.log("Validation Errors:", errors);

    setFormErrors(errors);
    return Object.keys(errors).length === 0; // Return true if no errors, false if there are errors
  };

  const displayErrMsg = (errMsg) => {
    setErrSuccessMsg({
      message: errMsg,
      status: false,
    });
  };

  const displaySuccessMsg = () => {
    setIsLoading(false);
    setErrSuccessMsg({
      message: "Profession has been added.",
      status: true,
    });
    setFormValues({
      typeName: "",
      shortDescription: "",
      longDescription: "",
      relatedDocuments: [],
      relatedFields: [],
      relatedJobFields: [],
    });
  };

  const handleInputChange = (e, fieldName, position) => {
    let name, value;

    if (typeof e === "string") {
      // If e is a string, it means this is a ReactQuill change event
      name = fieldName;
      value = e;
    } else {
      // Otherwise, it's a regular input change event
      ({ name, value } = e.target);
    }

    console.log("name, value ", name, value);

    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const submitJobType = async (event) => {
    event.preventDefault();
    setIsLoading(true);

    if (validateForm()) {

      const formattedData = {
        typeName: formValues.typeName,
        shortDescription: formValues.shortDescription,
        longDescription: formValues.longDescription,
        description: formValues.typeName,
        // relatedFields: "{'fields': []}",
        // relatedJobFields: "{'fields': []}",
        // relatedDocuments: "{'docs':[]}",
        relatedDocuments: JSON.stringify({ docs: JSON.parse(formValues.relatedDocuments) }),
        relatedFields: JSON.stringify({ fields: JSON.parse(formValues.relatedFields) }),
        relatedJobFields: JSON.stringify({ fields: JSON.parse(formValues.relatedJobFields) }),

      };

      try {
        const jobTypeResponse = await apiCall("openstaff/jobs/addJobType", "POST", formattedData, TOKEN);
        console.log("jobTypeResponse", jobTypeResponse);

        if (jobTypeResponse?.status === 200) {
          displaySuccessMsg();
        } else if (jobTypeResponse?.response?.status === 400) {
          displayErrMsg(jobTypeResponse?.response?.data?.errorMessage);
          setIsLoading(false);
        } else {
          displayErrMsg(jobTypeResponse?.response?.data?.message);
          setIsLoading(false);
        }
      } catch (error) {
        setIsLoading(false);
        displayErrMsg("Something went wrong!");
      }
    } else {
      setIsLoading(false);
      displayErrMsg("Check the form validation!");
    }
  };

  //   -------------------------dynamic fields---------------------
  //   const [rows, setRows] = useState([
  //     { title: "", mapping: "", required: false }
  //   ]);

  //   // Handle input change
  //   const handleInputChange = (e, index, field) => {
  //     const { value, type, checked } = e.target;
  //     const newRows = [...rows];
  //     newRows[index][field] = type === "checkbox" ? checked : value;
  //     setRows(newRows);
  //   };

  //   // Add new row
  //   const addRow = (e) => {
  //     e.preventDefault()
  //     setRows([...rows, { title: "", mapping: "", required: false }]);
  //   };

  //   // Remove row
  //   const removeRow = (index) => {
  //     if (rows.length > 1) {
  //       const newRows = rows.filter((_, i) => i !== index);
  //       setRows(newRows);
  //     }
  //   };

  return (
    <>
      <div>
        <Helmet>
          <title>Add New Profession | List of Professions Job Platform | {formatCompanyName()}</title>
          <meta name="description" content="Add a new profession to the list. Enter details, define roles, and expand your directory of job titles and career options." />
          <meta name="keywords" content="add profession, profession form, add job role, create profession, add occupation, admin profession form" />
        </Helmet>
      </div>
      <div className="section-full p-t120  p-b90 site-bg-white">
        <div className="container">
          <div className="row">
            <form id="jobseeker_profile">
              <div className="panel panel-default">
                <div className="panel-heading d-flex justify-content-between align-items-center wt-panel-heading p-a20">
                  <h3 className="panel-tittle mt-5">Add Profession</h3>
                </div>
                <div className="panel-body wt-panel-body p-a20 m-b30 ">
                  <div className="row">
                    <div className="col-xl-12 col-lg-12 col-md-12">
                      <div className="form-group">
                        <label>Profession</label>
                        <div className="ls-inputicon-box">
                          <input
                            className="form-control"
                            name="typeName"
                            type="text"
                            placeholder="Profession"
                            value={formValues.typeName}
                            onChange={(e) => handleInputChange(e, "typeName")}
                          />
                        </div>
                        {formErrors.typeName && (
                          <span className="error-message">
                            {formErrors.typeName}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-xl-12 col-lg-12 col-md-12">
                      <div className="form-group">
                        <label>Short Description</label>
                        <div className="ls-inputicon-box">
                          <input
                            className="form-control"
                            name="shortDescription"
                            type="text"
                            placeholder="Short Description"
                            value={formValues.shortDescription}
                            onChange={(e) => handleInputChange(e, "shortDescription")}
                          />
                        </div>
                        {formErrors.shortDescription && (
                          <span className="error-message">
                            {formErrors.shortDescription}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-xl-12 col-lg-12 col-md-12">
                      <div className="form-group city-outer-bx has-feedback">
                        <label>Long Description</label>
                        <div className="ls-inputicon-box">
                          <ReactQuill
                            theme="snow"
                            value={formValues.longDescription}
                            onChange={(value) => handleInputChange({ target: { name: 'longDescription', value } })}
                            placeholder="Long Description"
                            modules={{
                              toolbar: [
                                [{ 'font': [] }],
                                [{ size: [] }],
                                ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                                [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                                ['link', 'image'],
                                ['clean']
                              ]
                            }}
                            formats={[
                              'header', 'font', 'size',
                              'bold', 'italic', 'underline', 'strike', 'blockquote',
                              'list', 'bullet',
                              'link', 'image', 'video'
                            ]}
                          />
                          {formErrors.longDescription && (
                            <span className="error-message">
                              {formErrors.longDescription}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* Documents fields */}
                    <div className="col-xl-12 col-lg-12 col-md-12">
                      <div className="form-group">
                        <label>Documents (JSON)</label>
                        <span
                          style={{ marginLeft: 5, cursor: "pointer" }}
                          title={`[{
    "mapRecordInternalId": "3",
    "required": "false"
  }]`}
                          data-bs-toggle="tooltip"
                          data-bs-placement="top">
                          <i className="fa fa-info-circle" ></i>
                        </span>
                        <div className="ls-inputicon-box">
                          <textarea
                            className="form-control custom-textarea"
                            name="relatedDocuments"
                            value={formValues.relatedDocuments}
                            onChange={(e) => handleInputChange(e, "relatedDocuments")}
                            rows={10}
                            cols={50}
                          />

                        </div>
                        {formErrors.relatedDocuments && (
                          <span className="error-message">{formErrors.relatedDocuments}</span>
                        )}
                      </div>
                    </div>

                    {/* Profile fields */}
                    <div className="col-xl-12 col-lg-12 col-md-12">
                      <div className="form-group">
                        <label>Job Seeker Profile Questions (JSON)</label>
                        <span
                          style={{ marginLeft: 5, cursor: "pointer" }}
                          title={`[{
    "title": "What is the age group of the class?",
    "mapField": "strFld1",
    "required": true
  }]`}
                          data-bs-toggle="tooltip"
                          data-bs-placement="top">
                          <i className="fa fa-info-circle" ></i>
                        </span>
                        <div className="ls-inputicon-box">
                          <textarea
                            className="form-control custom-textarea"
                            name="relatedFields"
                            value={formValues.relatedFields}
                            onChange={(e) => handleInputChange(e, "relatedFields")}
                            rows={10}
                            cols={50}
                          />

                        </div>
                        {formErrors.relatedFields && (
                          <span className="error-message">{formErrors.relatedFields}</span>
                        )}
                      </div>
                    </div>

                    {/* Job fields */}
                    <div className="col-xl-12 col-lg-12 col-md-12">
                      <div className="form-group">
                        <label>Post Job Form Questions (JSON)</label>
                        <span
                          style={{ marginLeft: 5, cursor: "pointer" }}
                          title={`[{
    "title": "What is the age group of the class?",
    "mapField": "strFld1",
    "required": true
  }]`}
                          data-bs-toggle="tooltip"
                          data-bs-placement="top">
                          <i className="fa fa-info-circle" ></i>
                        </span>
                        <div className="ls-inputicon-box">
                          <textarea
                            className="form-control custom-textarea"
                            name="relatedJobFields"
                            value={formValues.relatedJobFields}
                            onChange={(e) => handleInputChange(e, "relatedJobFields")}
                            rows={10}
                            cols={50}
                          />

                        </div>
                        {formErrors.relatedJobFields && (
                          <span className="error-message">{formErrors.relatedJobFields}</span>
                        )}
                      </div>
                    </div>

                    <div className="row col-lg-6 col-md-12">
                      <ul className="nav" id="myTab" role="tablist">
                        <li className="nav-item" role="presentation">
                          <a
                            className="site-button"
                            onClick={() => navigateToProfessionsList()}
                            role="button"
                          >
                            Back
                          </a>
                        </li>
                        <li className="nav-item" role="presentation">
                          <button type="submit" className="site-button ms-3" onClick={submitJobType}>
                            {isLoading ? <Spinner /> : "Save Changes"}
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* )} */}
      {errSuccessMesg?.message !== "" ? <Toast message={errSuccessMesg} /> : ""}
    </>
  );
};

export default AddJobTypeForm;
